import { render, staticRenderFns } from "./FirstTimeView.vue?vue&type=template&id=493f96a6&scoped=true&"
import script from "./FirstTimeView.vue?vue&type=script&lang=ts&"
export * from "./FirstTimeView.vue?vue&type=script&lang=ts&"
import style0 from "./FirstTimeView.vue?vue&type=style&index=0&id=493f96a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f96a6",
  null
  
)

export default component.exports